const _ = "";
export {
  _ as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/banjian/banjian.vue3.js
// module id = 1245
// module chunks = 67